import type { ClientSearchResult } from "../types/client";

/**
 * Policy rows first (their order), then name rows (their order), one row per
 * `clientSk`. A duplicate keeps `matchedPolicyNumber` from the policy row and
 * `policyCount` from whichever row has one (the policy row's wins).
 */
export function mergeClientRows(
  nameRows: ClientSearchResult[],
  policyRows: ClientSearchResult[]
): ClientSearchResult[] {
  const bySk = new Map<number, ClientSearchResult>();
  for (const row of [...policyRows, ...nameRows]) {
    const seen = bySk.get(row.clientSk);
    if (!seen) {
      bySk.set(row.clientSk, { ...row });
      continue;
    }
    if (seen.policyCount === undefined && row.policyCount !== undefined) {
      seen.policyCount = row.policyCount;
    }
    if (seen.matchedPolicyNumber === undefined && row.matchedPolicyNumber !== undefined) {
      seen.matchedPolicyNumber = row.matchedPolicyNumber;
    }
  }
  return [...bySk.values()];
}
